<template>
  <div class="form-checkbox" @click="switchCheckbox()">
    <div class="form-checkbox__checkbox-wrapper">
      <icon-check-mark :class="[
        'form-checkbox__checkbox',
        _is_active ? 'form-checkbox__checkbox_checked' : '',
        is_error ? 'form-checkbox__checkbox_error' : '',
      ]"></icon-check-mark>
    </div>
      <div class="form-checkbox__label">
        <slot name="label">
          {{ $props?.label }}
        </slot>
      </div>
  </div>
</template>

<script setup>
import { ref, watch, defineExpose } from "vue";
import IconCheckMark from "@/components/ui/icons/IconCheckMark.vue";

const $props = defineProps(["value", "label", "is_error", "is_disabled"])
const $emit = defineEmits(["updateValue"])

const _is_active = ref($props.value)

function switchCheckbox () {
  if (!$props?.is_disabled) {
    _is_active.value = !_is_active.value
    $emit("updateValue", _is_active.value)
  }
}

function setCheckboxValueToTrue () {
  if (!$props?.is_disabled) {
    _is_active.value = true
    $emit("updateValue", _is_active.value)
  }
}

function setCheckboxValueToFalse () {
  if (!$props?.is_disabled) {
    _is_active.value = false
    $emit("updateValue", _is_active.value)
  }
}

watch($props, () => {
  _is_active.value = $props?.value
})

defineExpose({
  switchCheckbox,
  setCheckboxValueToTrue,
  setCheckboxValueToFalse,
  _is_active
});
</script>

<style lang="scss" scoped>
  .form-checkbox {
    display: flex;
    cursor: pointer;

    &__checkbox-wrapper {
      padding: 4px;
    }

    &__checkbox {
      padding: 2px;
      width: 16px;
      height: 16px;
      min-width: 16px;
      background-color: #FFF;
      border: 1px solid var(--border-color);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color .2s, border .2s;
      color:#fff;

      &:hover {
        border-color: var(--primary-color);
      }

      &_checked {
        border-color: var(--primary-color);
        background-color: var(--primary-color);
      }

      &_error {
        border-color: var(--error-color);

        &:hover {
          border-color: var(--error-color);
        }
      }
    }

    &__label {
      margin: 0 0 0 10px;
      font-size: 14px;
      line-height: 24px;
      user-select: none;
    }
  }
</style>
